

















































































































































































import {
  EditMode,
  CabinetConfigurationModel,
  CabinetReferenceType,
  CabinetConfigurationLevel,
  DocumentTypeConfigurationModel,
  CabinetReferenceConfigurationModel,
  CabinetConfigurationSettingNameConstants,
  ReferenceConfigurationModel,
  DocumentTypeMatchingRecordAction,
  StoreConstants
} from '@/types';
import MStoreAccordion from '@/components/shared/MStoreAccordion.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import ReferencesAccordion from '@/components/configuration/cabinet/ReferencesAccordion.vue';
import ReferenceToggleModal from '@/components/configuration/cabinet/ReferenceToggleModal.vue';
import Vue, { PropType } from 'vue';
import { CabinetConfigurationHelper, FormFieldValidation, ComponentHelper } from '@/mixins';
import { ObjectUtils } from '@/utils/objectUtils';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { EnumUtils } from '@/utils';
import { DocumentTypeEncryptionEnabledType } from '@/types/enums/DocumentTypeEncryptionEnabledType';

export default Vue.extend({
  name: 'DocumentTypeConfiguration',
  mixins: [FormFieldValidation, CabinetConfigurationHelper, ComponentHelper],
  data() {
    return {
      documentTypeConfigurationClone: {} as DocumentTypeConfigurationModel,
      cabinetConfigurationClone: {} as CabinetConfigurationModel,
      isLoading: true,
      referencesHaveChanged: false,
      referencesSelectedForLookupHaveChanged: false,
      referencesForSelection: [],
      referencesSelectedForLookup: []
    };
  },
  props: {
    editMode: {
      type: Number as PropType<EditMode>,
      required: true
    },
    cabinetConfiguration: {
      type: Object as () => CabinetConfigurationModel,
      required: true
    },
    documentTypeConfiguration: {
      type: Object as () => DocumentTypeConfigurationModel,
      required: true
    },
    submitting: {
      type: Boolean
    },
    IsParentLoading: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    async initialiseAsync(this: any) {
      const authorized = await this.checkAuthorizedAsync();
      if (authorized) {
        this.cloneCabinetConfiguration();
        this.cloneDocumentTypeConfiguration();
        this.checkLockedForEditMode(this.editMode);
        this.cloneReferencesforSelection();
      }
      this.isLoading = false;
    },
    cloneDocumentTypeConfiguration(this: any) {
      if (!ObjectUtils.isNullOrEmpty(this.documentTypeConfiguration)) {
        this.documentTypeConfigurationClone = ObjectUtils.deepCloneObject(this.documentTypeConfiguration);
        this.documentTypeConfigurationClone.modified = this.editMode === EditMode.Edit;
      }
    },
    cloneCabinetConfiguration(this: any) {
      if (!ObjectUtils.isNullOrEmpty(this.cabinetConfiguration)) {
        this.cabinetConfigurationClone = ObjectUtils.deepCloneObject(this.cabinetConfiguration);
        this.cabinetConfigurationClone.configurationChangeId = this.cabinetConfigurationChangeId;
      }
    },
    onReferencesChanged(this: any, cabinetConfiguration: CabinetConfigurationModel, documentTypeConfiguration: DocumentTypeConfigurationModel) {
      this.cabinetConfigurationClone = cabinetConfiguration;
      this.documentTypeConfigurationClone = documentTypeConfiguration;
      this.cloneReferencesforSelection();
      this.referencesHaveChanged = true;
    },
    onDirtyForm(this: any, isDirty: boolean) {
      if (!isDirty && (this.referencesHaveChanged || this.referencesSelectedForLookupHaveChanged)) {
        return;
      }
      this.setApplicationDirty(isDirty);
    },
    async onSubmitAsync(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();

        if (!this.documentTypeNameIsValid(this.documentTypeConfigurationClone)) {
          this.scrollToDocumentTypeName();
          return;
        }
        if (!isValid || !this.matchingDocumentActionIsValid()) {
          return;
        }

        this.setApplicationDirty(false);

        const documentTypeInCabinetConfigurationIndex = this.cabinetConfigurationClone.documentTypes.findIndex(
          (docType: DocumentTypeConfigurationModel) => docType.id === this.documentTypeConfigurationClone.id || docType.isNew
        );

        if (documentTypeInCabinetConfigurationIndex > -1) {
          this.cabinetConfigurationClone.documentTypes[documentTypeInCabinetConfigurationIndex] = this.documentTypeConfigurationClone;
        } else {
          this.cabinetConfigurationClone.documentTypes.push(this.documentTypeConfigurationClone);
        }

        this.$emit('submit', this.cabinetConfigurationClone);
      } catch (error) {
        this.$log('', error);
      }
    },
    onCancelButtonClicked(this: any) {
      this.$emit('cancel');
    },
    async checkAuthorizedAsync(this: any): Promise<boolean> {
      if (this.editMode !== EditMode.Add) {
        return true;
      }
      let authorized = false;
      try {
        await CabinetConfigurationService.checkAuthorizedWithErrorPageAsync();
        authorized = true;
      } catch (error) {
        this.$log(error);
      }
      return authorized;
    },
    cloneReferencesforSelection(this: any) {
      const allDocumentTypeReferences: any[] = (this.documentTypeReferences as CabinetReferenceConfigurationModel[])
        .filter((r) => !r.isDeleted)
        .map((r) => {
          return {
            text: r.description,
            value: `${r.referenceType}-${r.referenceNumber}`
          };
        });

      this.referencesForSelection = ObjectUtils.deepCloneObject(allDocumentTypeReferences);
      this.cloneReferencesSelectedForLookup();
    },
    cloneReferencesSelectedForLookup(this: any) {
      const referencesConfiguration = this.documentTypeConfigurationClone.referencesConfiguration;
      const lookupReferences: ReferenceConfigurationModel[] = referencesConfiguration.filter((x: ReferenceConfigurationModel) => x.storeReferenceConfiguration.lookup);

      const selectedReferences: any[] = this.referencesForSelection.filter((x: any) =>
        lookupReferences.some((r: ReferenceConfigurationModel) => `${r.referenceType}-${r.referenceNumber}` === x.value)
      );

      this.referencesSelectedForLookup = ObjectUtils.deepCloneObject(selectedReferences);
    },
    onLookupReferencesSelected(this: any, selectedReferences: any) {
      this.referencesSelectedForLookupHaveChanged = true;
      this.setApplicationDirty(true);
      this.documentTypeConfigurationClone.referencesConfiguration.forEach((r: ReferenceConfigurationModel) => (r.storeReferenceConfiguration.lookup = false));

      this.documentTypeConfigurationClone.referencesConfiguration
        .filter((r: ReferenceConfigurationModel) => selectedReferences.some((y: any) => y.value === `${r.referenceType}-${r.referenceNumber}`))
        .forEach((z: any) => (z.storeReferenceConfiguration.lookup = true));

      const documentDateIsLookupField = selectedReferences.some((x: any) => x.value === this.DOCUMENT_DATE_KEY);
      this.documentTypeConfigurationClone.storeConfiguration.documentDateIsLookupField = documentDateIsLookupField;

      this.cloneReferencesforSelection();
      this.$refs.matchExistingRecordAction.$refs.ValidationProvider.reset();
    },
    documentTypeNameIsValid(this: any, documentType: DocumentTypeConfigurationModel): boolean {
      const isValid: boolean = !this.cabinetConfigurationClone.documentTypes.some(
        (d: DocumentTypeConfigurationModel) => d.id !== documentType.id && d.description.toLowerCase() === documentType.description.toLowerCase()
      );

      if (!isValid) {
        this.$refs.documentTypeName.$refs.ValidationProvider.applyResult({
          errors: ['Name must be unique, existing document type has the same name'],
          valid: false,
          failedRules: {}
        });
      }
      return isValid;
    },
    matchingDocumentActionIsValid(this: any): boolean {
      const selectedReferences = this.cloneReferencesSelectedForLookupWithDocumentDate;
      if (
        this.documentTypeConfigurationClone.storeConfiguration.matchExistingRecordAction !== this.CREATE_NEW &&
        !this.documentTypeConfigurationClone.storeConfiguration.documentDateIsLookupField &&
        selectedReferences.length === 0
      ) {
        this.$refs.matchExistingRecordAction.$refs.ValidationProvider.applyResult({
          errors: ['When matching a document, at least one reference must be selected'],
          valid: false,
          failedRules: {}
        });

        return false;
      }
      return true;
    },
    scrollToDocumentTypeName(this: any) {
      const element = this.getElementById('documentTypeName') as HTMLElement;
      if (element) {
        this.setScrollIntoView(element, { block: 'end', inline: 'nearest' });
      }
    }
  },
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Getters.DocumentDateSetting,
      StoreConstants.CabinetConfiguration.Getters.DocumentTypeStoringConfigurationSetting,
      StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChangeId
    ]),
    documentTypeAccordionTitle(this: any) {
      return this.editMode === EditMode.Add
        ? `Add a Document Type to the ${this.cabinetConfigurationClone.description === undefined ? '' : this.cabinetConfigurationClone.description} Cabinet`
        : `Edit ${this.documentTypeConfigurationClone.description}`;
    },
    isAddMode(this: any) {
      return this.editMode === EditMode.Add;
    },
    isViewMode(this: any) {
      return this.editMode === EditMode.View;
    },
    anyLoading(this: any) {
      return this.isParentLoading || this.isLoading;
    },
    matchingRecordActionSettingValues(this: any) {
      return this.documentTypeStoringConfigurationSetting(CabinetConfigurationSettingNameConstants.MatchingRecordAction).settingValues;
    },
    documentDateSettingDescription(this: any) {
      return this.documentDateSetting(CabinetConfigurationSettingNameConstants.Description).description;
    },
    matchingRecordActionSettingDescription(this: any) {
      return this.documentTypeStoringConfigurationSetting(CabinetConfigurationSettingNameConstants.MatchingRecordAction).description;
    },
    clearReferencesAfterUpdateDescription(this: any) {
      return this.documentTypeStoringConfigurationSetting(CabinetConfigurationSettingNameConstants.ClearReferencesAfterUpdate).description;
    },
    documentTypeReferences(this: any): CabinetReferenceConfigurationModel[] {
      return this.cabinetConfigurationClone.cabinetReferences.filter(
        (x: CabinetReferenceConfigurationModel) =>
          x.referenceType === CabinetReferenceType.Common ||
          (this.editMode === EditMode.Add && x.documentTypeId == null && x.id == null) ||
          (x.documentTypeId !== null && x.documentTypeId === this.documentTypeConfigurationClone.id)
      );
    },
    documetDateReferenceForSelection(this: any) {
      const documentDateDescription: string = this.documentTypeConfigurationClone.storeConfiguration.documentDateDescription;
      return {
        text: documentDateDescription,
        value: this.DOCUMENT_DATE_KEY
      };
    },
    referencesForSelectionWithDocumentDate(this: any) {
      return this.referencesForSelection.concat(this.documetDateReferenceForSelection);
    },
    cloneReferencesSelectedForLookupWithDocumentDate(this: any) {
      const documentDateIsLookupField = this.documentTypeConfigurationClone.storeConfiguration.documentDateIsLookupField;
      if (documentDateIsLookupField) {
        return this.referencesSelectedForLookup.concat(this.documetDateReferenceForSelection);
      }
      return this.referencesSelectedForLookup;
    },
    cancelButtonText(this: any) {
      return this.isViewMode ? 'Close' : 'Cancel';
    },
    hasMultiValueReferences(this: any) {
      return this.documentTypeReferences.some((x: CabinetReferenceConfigurationModel) => x.isMultiValue);
    }
  },
  async mounted(this: any) {
    await this.initialiseAsync();
  },
  created(this: any) {
    this.CABINET_REFERENCE_TYPE = CabinetReferenceType.Common;
    this.DOCUMENT_TYPE_REFERENCE_TYPE = CabinetReferenceType.Document;
    this.CONFIGURATION_LEVEL = CabinetConfigurationLevel.DocumentType;
    this.DOCUMENT_DATE_KEY = 'DocumentDate';
    this.CREATE_NEW = DocumentTypeMatchingRecordAction.CreateNew;
    this.documentTypeEncryptionEnabledTypeOptions = EnumUtils.getEnumValues(DocumentTypeEncryptionEnabledType);
  },
  components: {
    MStoreAccordion,
    MStoreFormInput,
    ReferencesAccordion,
    MStoreFormSelect,
    ReferenceToggleModal,
    MStoreFormCheckbox,
    LoadingSpinner
  }
});
